/**
 * OpenIcon/index.js
 * desc: open icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const OpenIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="open icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.open.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M2 2.1875V16.1875H16V9.1875H18V16.1875C18 17.2875 17.1 18.1875 16 18.1875H2C0.89 18.1875 0 17.2875 0 16.1875V2.1875C0 1.0875 0.89 0.1875 2 0.1875H9V2.1875H2ZM11 2.1875V0.1875H18V7.1875H16V3.5975L6.17 13.4275L4.76 12.0175L14.59 2.1875H11Z" /></svg>
    </IconButton>
);


export default OpenIcon;
